import { Done, DoneAll } from '@mui/icons-material';
import React from 'react';


export const Message = ({ message, userId, status }) => {
    const username = localStorage.getItem('username');
    const isSender = message.senderId === username; // Replace 'yourUserId' with the actual sender's ID
    console.log("status: " + status);
    
    const getStatusIcon = (status) => {
        switch (status) {
            case 'sent':
                return <Done sx={{width:'15px'}}/>;
            case 'delivered':
                return <DoneAll sx={{width:'15px'}}/>;
            case 'read':
                return <i className="fas fa-eye"></i>;
            default:
                return null;
        }
    }
    // Format timestamp to "hh:mm AM/PM"
    const formatTimestamp = (timestamp) => {
        const date = timestamp?.toDate(); // Convert Firestore Timestamp to Date object
        const hours = date?.getHours();
        const minutes = date?.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = hours % 12 || 12; // Convert to 12-hour format
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
        return `${formattedHours}:${formattedMinutes} ${ampm}`;
    };

    const messageTime = formatTimestamp(message.timestamp);

    return (
        <li className={isSender ? 'repaly' : 'sender'}>
            <p>{message.message}</p>
            <span className="time">
                {message.timestamp && formatTimestamp(message.timestamp)}
                {isSender && getStatusIcon(status)}
            </span>
        </li>
    );
};
